import React from 'react';
import type { PercentGridPayload } from '../../core/types/payloads/percent_grid.types';
import { isVisualExerciseInstruction } from '../../core/print/visualExerciseMode';

const SERENITY_PRIMARY = '#8A7BFA';
const EMPTY_CELL = '#F1F5F9';
const GRID_STROKE = '#E2E8F0';

const COLS = 10;
const ROWS = 10;
const CELL = 22;
const GAP = 4;

export function PercentGridView({ payload }: { payload: PercentGridPayload }) {
  const filledCount = Math.min(100, Math.max(0, Math.round(payload.percentage)));
  const hideAnswer = isVisualExerciseInstruction(payload.instruction);
  const width = COLS * CELL + (COLS - 1) * GAP;
  const height = ROWS * CELL + (ROWS - 1) * GAP;

  return (
    <div className="space-y-4">
      <p className="text-sm leading-relaxed text-slate-700 print:text-[#334155]">{payload.instruction}</p>
      <div className="flex flex-col items-center gap-3">
        <svg viewBox={`0 0 ${width} ${height}`} className="h-auto w-full max-w-xs" role="img" aria-hidden>
          {Array.from({ length: 100 }, (_, index) => {
            const row = Math.floor(index / COLS);
            const col = index % COLS;
            const filled = index < filledCount;
            const x = col * (CELL + GAP);
            const y = row * (CELL + GAP);
            return (
              <rect
                key={index}
                x={x}
                y={y}
                width={CELL}
                height={CELL}
                rx={3}
                fill={filled ? SERENITY_PRIMARY : EMPTY_CELL}
                stroke={GRID_STROKE}
                strokeWidth={0.75}
              />
            );
          })}
        </svg>
        {hideAnswer ? (
          <p className="text-lg font-semibold tabular-nums text-slate-800 print:border-b print:border-slate-400 print:px-6">
            [ ] %
          </p>
        ) : (
          <p className="text-lg font-semibold tabular-nums text-slate-800">{filledCount}%</p>
        )}
      </div>
    </div>
  );
}
